import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { StyledCreditCardChoiceModal } from '../CreditCardChoiceModal/CreditCardChoice.styled';

const ConfirmationModal = ({ show, onHide, onChargeClick }) => {
    const { t } = useTranslation();
    const [chargeBtnDisabled, setChargeBtnDisabled] = useState(true);
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = e => setInputValue(e.target.value);

    useEffect(() => {
        if (inputValue && (inputValue.toLowerCase() === t('creditCardChoice.confirmWord').toLowerCase())){
            setChargeBtnDisabled(false);
        }
        else{
            setChargeBtnDisabled(true);
        }
    }, [inputValue]);

    return (
        <StyledCreditCardChoiceModal
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header>
                <Modal.Title>{t('creditCardChoice.headers.confirm')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="info-text">
                    <div>{t('creditCardChoice.infoText.verify')}</div>
                    <div>{t('creditCardChoice.infoText.type')}</div>
                </div>

                <div
                    className="form-group"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <label htmlFor="Check-number" style={{ width: 'auto' }}>{t('creditCardChoice.infoText.typeConfirm')}</label>
                    <input
                        type="text"
                        className='form-control'
                        name="confirm"
                        value={inputValue}
                        onChange={handleInputChange}
                        style={{ width: '200px', marginTop: '10px' }}
                    />
                </div>

                <button
                    className="bllink-button"
                    disabled={chargeBtnDisabled}
                    onClick={onChargeClick}
                >
                    {t('creditCardChoice.btns.charge')}
                </button>
            </Modal.Body>
        </StyledCreditCardChoiceModal>
    );
};

export default ConfirmationModal;
